
import { useNavigate } from "react-router";
import { toast } from "react-toastify";


//url for production
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ") {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];





//! MY FUNCTIONS
const getToken = () => {
  return localStorage.getItem("accessToken");
};
const getLanguage = () => {
  return localStorage.getItem("language") || "en";
};

export const createHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      Language: getLanguage(),
    },
  };
};

export const createFormHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
      Language: getLanguage(),
    },
  };
};
export const createHeadersAdmin = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};
export const createFormHeadersAdmin = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};

export const validateDrivingLicense = (value) => {
  const pattern = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/;
  return pattern.test(value);
};
export const isValidEmail = (email) => {
  // const pattern = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._]*@(?=[a-zA-Z])([a-zA-Z]+\.[a-zA-Z]{2,})$/;
  const pattern =
    /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._]*[a-zA-Z0-9]@[a-zA-Z][a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email);
};

export function ValidateImg(file, callback) {
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }
    // File signature check
    const isPng = header === "89504e47"; // PNG signature
    const isJpeg =
      header === "ffd8ffe0" || // JPEG signature
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    const isValidImage = isPng || isJpeg;
    callback(isValidImage); // Pass the result to the callback function
  };
  reader.onerror = function () {
    callback(false); // In case of an error, return false
  };
  reader.readAsArrayBuffer(file.slice(0, 4)); // Read the first 4 bytes of the file
}
export function ValidateImgWithSize(file, callback) {
  const maxSizeInBytes = 1 * 1024 * 1024; // 1MB
  const requiredWidth = 1920;
  const requiredHeight = 566;

  //  Step 1: Check file size
  if (file.size > maxSizeInBytes) {
    return callback(false, "File size must be less than or equal to 1MB");
  }

  //  Step 2: Check file type via magic number
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47";
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    const isValidImage = isPng || isJpeg;

    if (!isValidImage) {
      return callback(
        false,
        "Invalid file type. Only PNG and JPEG images are allowed"
      );
    }

    //  Step 3: Check dimensions
    const imgReader = new FileReader();
    imgReader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        if (img.width === requiredWidth && img.height === requiredHeight) {
          callback(true, "Image is valid");
        } else {
          callback(
            false,
            `Invalid image dimensions. Required: ${requiredWidth}x${requiredHeight}px`
          );
        }
      };
      img.onerror = function () {
        callback(false, "Unable to read image dimensions");
      };
      img.src = e.target.result;
    };
    imgReader.onerror = function () {
      callback(false, "Failed to load image for dimension check");
    };
    imgReader.readAsDataURL(file);
  };

  reader.onerror = function () {
    callback(false, "Error reading file header");
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
}
export function ValidateThumbWithSize(file, callback) {
  const maxSizeInBytes = 1 * 500 * 1024; // 500KB
  const requiredWidth = 250;
  const requiredHeight = 250;

  //  Step 1: Check file size
  if (file.size > maxSizeInBytes) {
    return callback(false, "File size must be less than or equal to 500KB");
  }

  //  Step 2: Check file type via magic number
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47";
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    const isValidImage = isPng || isJpeg;

    if (!isValidImage) {
      return callback(
        false,
        "Invalid file type. Only PNG and JPEG images are allowed"
      );
    }

    //  Step 3: Check dimensions
    const imgReader = new FileReader();
    imgReader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        if (img.width <= requiredWidth && img.height <= requiredHeight) {
          callback(true, "Image is valid");
        } else {
          callback(
            false,
            `Invalid image dimensions. Required: ${requiredWidth}x${requiredHeight}px`
          );
        }
      };
      img.onerror = function () {
        callback(false, "Unable to read image dimensions");
      };
      img.src = e.target.result;
    };
    imgReader.onerror = function () {
      callback(false, "Failed to load image for dimension check");
    };
    imgReader.readAsDataURL(file);
  };

  reader.onerror = function () {
    callback(false, "Error reading file header");
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
}
export function ValidateImgWithSizeVIPbanner(file, callback) {
  const requiredWidth = 200;
  const requiredHeight = 200;

  //  Step 2: Check file type via magic number
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47";
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";

    const isValidImage = isPng || isJpeg;

    if (!isValidImage) {
      return callback(
        false,
        "Invalid file type. Only PNG and JPEG images are allowed"
      );
    }

    //  Step 3: Check dimensions
    const imgReader = new FileReader();
    imgReader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        if (img.width === requiredWidth && img.height === requiredHeight) {
          callback(true, "Image is valid");
        } else {
          callback(
            false,
            `Invalid image dimensions. Required: ${requiredWidth}x${requiredHeight}px`
          );
        }
      };
      img.onerror = function () {
        callback(false, "Unable to read image dimensions");
      };
      img.src = e.target.result;
    };
    imgReader.onerror = function () {
      callback(false, "Failed to load image for dimension check");
    };
    imgReader.readAsDataURL(file);
  };

  reader.onerror = function () {
    callback(false, "Error reading file header");
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
}
// to show email in  karamveer[dot]yadav[at]nic[dot]in format
export const obfuscateEmail = (email) => {
  return email.replace(/@/g, "[at]").replace(/\./g, "[dot]");
};

// export function ValidateImgPdf(file, callback) {
//   const reader = new FileReader();
//   reader.onloadend = function (event) {
//     const arr = new Uint8Array(event.target.result).subarray(0, 4);
//     let header = "";
//     for (let i = 0; i < arr.length; i++) {
//       header += arr[i].toString(16);
//     }
//     // File signature check
//     const isPng = header === "89504e47"; // PNG signature
//     const isJpeg =
//       header === "ffd8ffe0" || // JPEG signature
//       header === "ffd8ffe1" ||
//       header === "ffd8ffe2" ||
//       header === "ffd8ffe3" ||
//       header === "ffd8ffe8";
//     const isPdf = header === "25504446";

//     const isValidImage = isPng || isJpeg || isPdf;
//     callback(isValidImage); // Pass the result to the callback function
//   };
//   reader.onerror = function () {
//     callback(false); // In case of an error, return false
//   };
//   reader.readAsArrayBuffer(file.slice(0, 4)); // Read the first 4 bytes of the file
// }

export function ValidateImgPdf(file, callback) {
  const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
  const allowedExtensions = /\.(png|jpe?g|pdf)$/i;

  // Basic MIME and extension check first
  if (!allowedTypes.includes(file.type) || !allowedExtensions.test(file.name)) {
    return callback(false);
  }

  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPng = header === "89504e47"; // PNG
    const isJpeg =
      header === "ffd8ffe0" ||
      header === "ffd8ffe1" ||
      header === "ffd8ffe2" ||
      header === "ffd8ffe3" ||
      header === "ffd8ffe8";
    const isPdf = header === "25504446"; // PDF

    const isValid = isPng || isJpeg || isPdf;
    callback(isValid);
  };

  reader.onerror = function () {
    callback(false);
  };

  // Read the first 4 bytes of the file
  reader.readAsArrayBuffer(file.slice(0, 4));
}

export function ValidatePdf(file, callback) {
  const pdfMagicNumber = "255044462d"; // PDF magic number

  // Step 1: Check file type via magic number
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 8);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    const isPdf = header.startsWith(pdfMagicNumber);

    if (!isPdf) {
      return callback(false, "Invalid file type. Only PDF files are allowed");
    }

    callback(true, "File is a valid PDF");
  };

  reader.onerror = function () {
    callback(false, "Error reading file header");
  };

  reader.readAsArrayBuffer(file.slice(0, 8));
}

export function ValidateDocFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 8);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16).padStart(2, "0"); // Proper padding
    }

    const isDoc = header.startsWith("d0cf11e0"); // Legacy .doc

    // Common ZIP signatures used by .docx files
    const zipSignatures = ["504b0304", "504b0506", "504b0708"];
    const isDocx = zipSignatures.some((sig) => header.startsWith(sig));

    const isValidDoc = isDoc || isDocx;

    if (!isValidDoc) {
      callback(false, "Invalid file type. Only DOC or DOCX files are allowed.");
    } else {
      callback(true, "File is a valid DOC/DOCX");
    }
  };

  reader.onerror = function () {
    callback(false, "Error reading file header");
  };

  reader.readAsArrayBuffer(file.slice(0, 8)); // Read more bytes for better accuracy
}
export const validateUrl = (url) => {
  if (/^[a-zA-Z0-9/-]+$/.test(url)) {
    return true;
  }
  return "Enter correct url";
};

const useLogout = () => {
  const navigate = useNavigate();
  const logoutAction = (msg) => {
    console.log("logout")
    localStorage.removeItem("IMAGE_BASE_URL");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("sideBar");
    localStorage.removeItem("userDetail");
    toast.error(msg);
    navigate("/auth-login");
  };

  return logoutAction;
};
export const getSmartInitials = (fullName) => {
  if (!fullName) return "";
  const names = fullName.trim().split(/\s+/);
  const firstInitial = names[0].charAt(0).toUpperCase();
  const secondInitial = names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : "A";
  return firstInitial + secondInitial;
};
export default useLogout;
